module.exports = __webpack_public_path__ + "fonts/silktype-silkserif-medium.0080c1fd99278cf935ed3b566cd9c3fe.ttf";